<template>
	<div class="major-select-panel">
		<!-- 顶部本科/专科切换 + 搜索 -->
		<div class="panel-tabs">
			<span class="tab-item" v-for="(level, levelindex) in majorLevelList" :key="levelindex"
				@click="handleLevelChange(levelindex + 1)" :class="{ active: majorLevel === levelindex + 1 }">
				{{ level }}
			</span>
			<div class="search-box">
				<el-input type="text" placeholder="输入要查询的专业名称" v-model="majorKeyword" @confirm="getMajorList"></el-input>
				<button class="search-btn" @click="getMajorList">搜索</button>
			</div>
		</div>

		<!-- 大类滚动栏 -->
		<div class="category-tabs">
			<div class="back-btn flex-center" @click="scrollCategory('left')">
				<i class="el-icon-arrow-left font12"></i>
			</div>
			<div class="category-scroll-wrap" ref="categoryScrollWrap">
				<div class="category-scroll-content" ref="categoryScrollContent">
					<span class="category-tab" v-for="(cat, catindex) in majorOption" :key="catindex"
						@click="handleMajorChange(1, cat, catindex)" :class="{ active: currentCategoryIndex === catindex }">
						{{ cat.name }}
						<span class="count-badge">{{ getCategorySelectedCount(cat.id) }}</span>
					</span>
				</div>
			</div>
			<div class="next-btn flex-center" @click="scrollCategory('right')">
				<i class="el-icon-arrow-right font12"></i>
			</div>
		</div>

		<!-- 左侧一级分类 + 右侧二级专业列表 -->
		<div class="panel-content">
			<div class="sidebar">
				<div class="sidebar-item" v-for="(first, firstindex) in majorFirstOpt" :key="firstindex"
					@click="handleMajorChange(2, first, firstindex)" :class="{ active: currentFirstIndex === firstindex }">
					{{ first.name }}
					<span class="count-badge">({{ getFirstSelectedCount(first.id) }})</span>
				</div>
			</div>
			<div class="major-list">
				<div class="major-item all-select" @click="toggleAllSelect">
					<label class="flex-startCenter">
						<span class="checkmark" :class="{ active: isAllSelected }"></span>
						全选
					</label>
				</div>
				<div class="major-item" v-for="(second, secondIndex) in majorSecendOpt" :key="secondIndex"
					@click="handleMajorChange(3, second, secondIndex)">
					<label class="flex-startCenter">
						<span class="checkmark" :class="{ active: second.active }"></span>
						{{ second.name }}
					</label>
				</div>
			</div>
		</div>

		<!-- 底部操作栏 -->
		<div class="panel-footer">
			<span class="selected-count">
				已选{{ selectedMajors.size }}个
			</span>
			<div class="footer-btns">
				<button class="btn-clear" @click="clearAll">清空已选</button>
				<button class="btn-confirm" @click="confirmSelected">确定</button>
			</div>
		</div>
	</div>
</template>

<script>
	import * as schoolApi from '@/api/school'

	export default {
		name: 'OptionMajor',
		props: {
			initLevel: {
				type: Number,
				default: 1
			},
			initSelectedMajorIds: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				majorLevel: 1,
				majorLevelList: ['本科', '职业本科', '专科'],
				majorKeyword: '',
				majorOption: [],
				majorFirstOpt: [],
				majorSecendOpt: [],
				currentCategoryIndex: 0,
				currentFirstIndex: 0,
				selectedMajors: new Map(),
				pendingSelectedIds: [] // 待应用的选中专业 ID
			}
		},
		computed: {
			// 全选状态
			isAllSelected() {
				if (this.majorSecendOpt.length === 0) return false
				return this.majorSecendOpt.every(item => item.active === true)
			}
		},
		watch: {
			initLevel: {
				immediate: true,
				handler(val) {
					this.majorLevel = val
					this.getMajorList()
				}
			},
			initSelectedMajorIds: {
				immediate: true,
				handler(val) {
					// 将传入的 ID 暂存，等待专业列表加载后再应用
					this.pendingSelectedIds = val || []
					this.applyPendingSelectedIds()
				}
			}
		},
		mounted() {
			this.getMajorList()
		},
		methods: {
			async getMajorList() {
				try {
					const res = await schoolApi.majors({
						level: this.majorLevel,
						keyword: this.majorKeyword
					})
					this.majorOption = res?.data || []

					// 重置大类选中索引为第一个
					this.currentCategoryIndex = 0

					if (this.majorOption.length > 0) {
						const defaultCategory = this.majorOption[0]
						this.majorFirstOpt = defaultCategory.children || []

						// 重置一级分类选中索引为第一个
						this.currentFirstIndex = 0

						const defaultFirst = this.majorFirstOpt[0] || {}
						this.majorSecendOpt = defaultFirst.children || []
					} else {
						this.majorFirstOpt = []
						this.majorSecendOpt = []
						this.currentFirstIndex = 0
					}

					// 应用待处理的选中项
					this.applyPendingSelectedIds()
					this.restoreMajorActiveStatus()
					this.$nextTick(() => {
						this.calcMaxScrollLeft()
						// 重置滚动位置
						if (this.$refs.categoryScrollWrap) {
							this.$refs.categoryScrollWrap.scrollLeft = 0
						}
					})
				} catch (error) {
					this.majorOption = []
					this.majorFirstOpt = []
					this.majorSecendOpt = []
					this.currentCategoryIndex = 0
					this.currentFirstIndex = 0
					this.$message.error('加载专业数据失败，请重试')
				}
			},


			// 应用待处理的选中专业 ID
			applyPendingSelectedIds() {
				if (!this.pendingSelectedIds.length) return

				// 收集当前所有可用的二级专业
				const allSecondMajors = []
				this.majorOption.forEach(category => {
					;
					(category.children || []).forEach(first => {
						;
						(first.children || []).forEach(second => {
							allSecondMajors.push(second)
						})
					})
				})

				const idToMajorMap = new Map(allSecondMajors.map(m => [m.id, m]))

				// 将待应用的 ID 转为完整对象存入 selectedMajors
				this.pendingSelectedIds.forEach(id => {
					const major = idToMajorMap.get(id)
					if (major) {
						this.selectedMajors.set(id, major)
					} else {
						// 如果当前列表中没有该专业，仍用 id 占位，后续列表加载时会补充
						this.selectedMajors.set(id, {
							id
						})
					}
				})

				// 清空待处理列表
				this.pendingSelectedIds = []
			},

			handleLevelChange(level) {
				if (this.majorLevel === level) return
				this.majorLevel = level
				// 切换等级时清空搜索关键词
				this.majorKeyword = ''
				// 重置选中索引
				this.currentCategoryIndex = 0
				this.currentFirstIndex = 0
				this.getMajorList()
			},

			handleMajorChange(level, item, index) {
				if (level === 1) {
					this.currentCategoryIndex = index
					this.majorFirstOpt = item.children || []
					this.currentFirstIndex = 0
					this.majorSecendOpt = this.majorFirstOpt.length > 0 ? this.majorFirstOpt[0].children || [] : []
					// 切换大类后重新应用待处理选中
					this.applyPendingSelectedIds()
				} else if (level === 2) {
					this.currentFirstIndex = index
					this.majorSecendOpt = item.children || []
					// 切换一级分类后重新应用待处理选中
					this.applyPendingSelectedIds()
				} else if (level === 3) {
					this.$set(item, 'active', !item.active)
					if (item.active) {
						this.selectedMajors.set(item.id, item)
					} else {
						this.selectedMajors.delete(item.id)
					}
				}
				this.restoreMajorActiveStatus()
			},

			// 恢复状态
			restoreMajorActiveStatus() {
				this.majorSecendOpt.forEach(item => {
					const isSelected = this.selectedMajors.has(item.id)
					this.$set(item, 'active', isSelected)
					if (isSelected) {
						// 用列表中的完整对象替换 Map 中可能只有 id 的旧对象
						this.selectedMajors.set(item.id, item)
					}
				})
			},

			// 全选
			toggleAllSelect() {
				const allSelected = this.isAllSelected
				this.majorSecendOpt.forEach(item => {
					const newActive = !allSelected
					this.$set(item, 'active', newActive)

					if (newActive) {
						this.selectedMajors.set(item.id, item)
					} else {
						this.selectedMajors.delete(item.id)
					}
				})
			},

			// 清空
			clearAll() {
				this.selectedMajors.clear()
				this.majorSecendOpt.forEach(item => {
					this.$set(item, 'active', false)
				})
				this.$emit('clear')
			},

			confirmSelected() {
				// 收集当前所有可用的二级专业，用于补充完整信息
				const allSecondMajors = []
				this.majorOption.forEach(category => {
					;
					(category.children || []).forEach(first => {
						;
						(first.children || []).forEach(second => {
							allSecondMajors.push(second)
						})
					})
				})
				const idToMajorMap = new Map(allSecondMajors.map(m => [m.id, m]))

				// 确保所有选中的专业都有完整信息
				const selectedList = Array.from(this.selectedMajors.values()).map(major => {
					if (!major.name && idToMajorMap.has(major.id)) {
						return idToMajorMap.get(major.id)
					}
					return major
				})

				const selectedIds = selectedList.map(item => item.id)
				const selectedData = {
					totalCount: selectedList.length,
					groups: [{
						name: '专业',
						selectedItems: selectedList,
						selectedIds: selectedIds.join(',')
					}]
				}

				this.$emit('confirm', {
					ids: selectedIds,
					list: selectedList,
					formatData: selectedData
				})
			},

			// 计算某大类下已选中的专业数量
			getCategorySelectedCount(categoryId) {
				const countSelectedInChildren = (children) => {
					if (!children) return 0
					let count = 0
					children.forEach(child => {
						if (child.children) {
							count += countSelectedInChildren(child.children)
						}
						if (this.selectedMajors.has(child.id)) {
							count++
						}
					})
					return count
				}
				const category = this.majorOption.find(item => item.id === categoryId)
				return category ? countSelectedInChildren(category.children) : 0
			},

			// 计算某一级分类下已选中的专业数量
			getFirstSelectedCount(firstId) {
				const firstItem = this.majorFirstOpt.find(item => item.id === firstId)
				if (!firstItem || !firstItem.children) return 0
				return firstItem.children.filter(item => this.selectedMajors.has(item.id)).length
			},

			calcMaxScrollLeft() {
				const wrap = this.$refs.categoryScrollWrap
				if (!wrap) return
				this.maxScrollLeft = Math.max(0, wrap.scrollWidth - wrap.clientWidth)
			},
			// 左右滚动
			scrollCategory(direction) {
				const wrap = this.$refs.categoryScrollWrap
				if (!wrap) return

				const step = 300
				let newScrollLeft

				if (direction === 'left') {
					newScrollLeft = Math.max(0, wrap.scrollLeft - step)
				} else {
					const maxScroll = wrap.scrollWidth - wrap.clientWidth
					newScrollLeft = Math.min(maxScroll, wrap.scrollLeft + step)
				}

				wrap.scrollTo({
					left: newScrollLeft,
					behavior: 'smooth'
				})
			},

			// 删除已选专业（供父组件调用）
			deleteSelectedMajor(majorId) {
				if (this.selectedMajors.has(majorId)) {
					this.selectedMajors.delete(majorId)
					this.restoreMajorActiveStatus()
					this.$forceUpdate()
					this.$emit('delete', majorId)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-input__inner {
			height: 35px;
			line-height: 35px;
			border: none !important;
			border-radius: 8px;
			outline: none;
		}
	}

	.major-select-panel {
		width: 700px;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

		// 顶部标签栏
		.panel-tabs {
			display: flex;
			align-items: center;
			padding: 12px;
			border-bottom: 1px solid #f0f0f0;

			.tab-item {
				padding: 8px 16px;
				margin-right: 8px;
				font-size: 16px;
				color: #666;
				cursor: pointer;
				border-bottom: 2px solid transparent;

				&.active {
					color: #28b05e;
					border-bottom-color: #28b05e;
					font-weight: 500;
				}
			}

			.search-box {
				margin-left: auto;
				display: flex;
				align-items: center;
				border-radius: 8px;
				border: 1px solid #28b05e;
				background: #28b05e;

				.search-btn {
					width: 50px;
					height: 35px;
					line-height: 35px;
					text-align: center;
					background: #28b05e;
					color: #fff;
					font-size: 14px;
					border: none;
					border-radius: 0 4px 4px 0;
					cursor: pointer;
				}
			}
		}

		// 大类滚动栏
		.category-tabs {
			display: flex;
			align-items: center;
			padding: 12px 20px;
			border-bottom: 1px solid #f0f0f0;

			.back-btn,
			.next-btn {
				background: none;
				border: none;
				color: #999;
				cursor: pointer;
				border: 1px solid #999;
				border-radius: 50%;
				width: 20px;
				height: 20px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
			}

			.category-scroll-wrap {
				flex: 1;
				overflow-x: auto;
				overflow-y: hidden;
				position: relative;
				margin: 0 8px;
				scroll-behavior: smooth;

				// 隐藏滚动条
				&::-webkit-scrollbar {
					display: none;
				}

				-ms-overflow-style: none;
				scrollbar-width: none;
			}

			.category-scroll-content {
				display: flex;
				align-items: center;
				flex-wrap: nowrap;
				white-space: nowrap;
				gap: 8px;
				transition: transform 0.3s ease;
				will-change: transform;
			}

			.category-tab {
				padding: 6px 12px;
				font-size: 14px;
				color: #666;
				background: #f5f5f5;
				border: none;
				border-radius: 4px;
				cursor: pointer;
				display: inline-flex;
				align-items: center;
				flex-shrink: 0;

				&.active {
					background: rgba(29, 100, 255, 0.1);
					color: #28b05e;
				}

				.count-badge {
					margin-left: 4px;
					font-size: 12px;
				}
			}
		}

		// 内容区
		.panel-content {
			display: flex;

			.sidebar {
				width: 200px;
				height: 300px;
				overflow-y: auto;
				background: #f8f8f8;
				border-right: 1px solid #f0f0f0;
				padding: 16px 0;

				.sidebar-item {
					padding: 12px 20px;
					font-size: 15px;
					color: #333;
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: space-between;

					&.active {
						color: #28b05e;
						font-weight: 500;
						border-left: 3px solid #1D64FF;
					}

					.count-badge {
						font-size: 12px;
						color: #999;
					}
				}
			}

			.major-list {
				flex: 1;
				height: 300px;
				overflow-y: auto;
				padding: 12px 20px;
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
				grid-auto-rows: min-content;
				gap: 8px;
				align-content: flex-start;
				align-items: center;

				.major-item {
					display: flex;
					align-items: center;
					justify-content: flex-start;
					padding: 8px 12px;
					border-radius: 4px;
					width: 100%;
					box-sizing: border-box;
					cursor: pointer;

					&.all-select {
						grid-column: 1 / -1; // 全选占满一行
						font-weight: 500;
					}

					.checkmark {
						width: 16px;
						height: 16px;
						border: 1px solid #d9d9d9;
						border-radius: 2px;
						margin-right: 8px;
						display: flex;
						align-items: center;
						justify-content: center;

						&.active {
							background: #28b05e;
							border-color: #28b05e;

							&::after {
								content: '✔';
								color: #fff;
								font-size: 12px;
							}
						}
					}
				}
			}
		}

		// 底部操作栏
		.panel-footer {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 16px 20px;
			border-top: 1px solid #f0f0f0;

			.selected-count {
				font-size: 14px;
				color: #666;
			}

			.footer-btns {
				display: flex;
				gap: 12px;

				.btn-clear {
					padding: 8px 20px;
					border-radius: 8px;
					font-size: 14px;
					cursor: pointer;
					border: 1px solid #28b05e;
					color: #28b05e;
					background: #fff;
				}

				.btn-confirm {
					padding: 8px 30px;
					border-radius: 8px;
					font-size: 14px;
					cursor: pointer;
					border: 1px solid #28b05e;
					color: #fff;
					background: #28b05e;
					border: none;
				}
			}
		}
	}
</style>
